import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              视频吃瓜
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
              独家实拍视频，用画面讲述最真实的爆料故事
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
              >
                <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-[10px] font-medium bg-black/70 text-background-50 whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-heading text-sm md:text-base text-foreground-800 line-clamp-2 leading-snug mb-2">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>
                    {item.views}次播放
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}